import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

export default function PreviewBadges({
  photo,
  handleOnClick,
  viewingSizeSelected,
  isSelected,
  children,
}) {
  const {
    quantity,
    size: { title },
  } = photo;

  return (
    <div className="preview-badges-wrapper position-relative">
      {quantity > 1 && (
        <span
          role="button"
          className="preview-badge preview-badge__quantity left">
          {quantity}
        </span>
      )}
      <span
        role="button"
        className="preview-badge preview-badge__right"
        onClick={handleOnClick}>
        <span
          className={ClassNames('preview-badge__tick', {
            'p-0': viewingSizeSelected,
            selected: isSelected,
          })}></span>
        {!viewingSizeSelected && (
          <span className="preview-badge__title pl-0">{title}</span>
        )}
      </span>
      {children}
    </div>
  );
}

PreviewBadges.propTypes = {
  isSelected: PropTypes.bool,
};

PreviewBadges.defaultProps = {
  isSelected: false,
};
